import { Observable } from 'rxjs';
import { ApiResponse } from './types.domain';

/**
 * Basiq has delivered an application's bank statements, so its Opportunity no longer has to wait
 * for them. Queued by azure-functions-callbacks; api2 checks the stage before publishing it.
 */
export const BANK_STATEMENTS_RECEIVED_JOB_TYPE = 'bank-statements-received';

/**
 * Outbox statuses of a row that has not reached a terminal state (succeeded or dead-lettered).
 * Shared because writers outside api2 check for an unfinished row before queueing another.
 */
export const SALESFORCE_OUTBOX_IN_FLIGHT_STATUSES = ['pending', 'published', 'failed'] as const;

/**
 * Ordering key for writes to a Salesforce record, or grouped under it as a parent, e.g. an
 * opportunity: its id in the case-sensitive 15-character form. Callers hold a mix of 15- and
 * 18-character ids for the same record, and the 18-character form only appends a checksum.
 */
export const salesforceParentOrderingKey = (salesforceId: string): string => String(salesforceId).trim().slice(0, 15);

/** A queued Salesforce write that sf-sync-service gave up on, as shown to operators. */
export interface DeadletteredSalesforceJob {
  correlationId: string;
  jobType: string;
  entityType: string | null;
  entityId: string | null;
  /** A summary of why the write failed; never the payload. */
  lastError: string | null;
  deadletteredAt: string | null;
  /** A later write of the same kind to the same record has been queued since, so it cannot be requeued. */
  superseded: boolean;
}

/** The portal records a dead-lettered write can be shown against. */
export type SalesforceSyncRecordType = 'application' | 'accreditation';

export type GetDeadletteredSalesforceJobsFn = (recordType: SalesforceSyncRecordType, recordId: number) => Observable<DeadletteredSalesforceJob[]>;

export type RequeueDeadletteredSalesforceJobFn = (correlationId: string) => Observable<ApiResponse>;
